module.exports = __webpack_public_path__ + "static/media/lion-ring.9d0c8d6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/lion-ring.jpg
// module id = 201
// module chunks = 0